module.exports = __webpack_public_path__ + "img/Templates.9666f8af.svg";